import React, { useState, useEffect } from 'react';
import Login from './components/Login';
import ExpenseTable from './components/ExpenseTable';
import ExpenseModal from './components/ExpenseModal';
import YearSettings from './components/YearSettings';
import { expensesAPI, authAPI } from './services/api';
import './styles/App.css';

function App() {
  const [user, setUser] = useState(null);
  const [expenses, setExpenses] = useState([]);
  const [loading, setLoading] = useState(true);
  const [searchTerm, setSearchTerm] = useState('');
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [editingExpense, setEditingExpense] = useState(null);

  useEffect(() => {
    checkAuth();
  }, []);

  useEffect(() => {
    if (user) {
      fetchExpenses();
    }
  }, [user, searchTerm]);

  const checkAuth = async () => {
    const token = localStorage.getItem('token');
    const savedUser = localStorage.getItem('user');

    if (token && savedUser) {
      try {
        await authAPI.verify();
        setUser(JSON.parse(savedUser));
      } catch (error) {
        localStorage.removeItem('token');
        localStorage.removeItem('user');
      }
    }
    setLoading(false);
  };

  const fetchExpenses = async () => {
    try {
      const response = await expensesAPI.getAll(searchTerm);
      setExpenses(response.data);
    } catch (error) {
      console.error('Error fetching expenses:', error);
    }
  };

  const handleLogin = (userData) => {
    setUser(userData);
  };

  const handleLogout = () => {
    localStorage.removeItem('token');
    localStorage.removeItem('user');
    setUser(null);
    setExpenses([]);
  };

  const handleAddNew = () => {
    setEditingExpense(null);
    setIsModalOpen(true);
  };

  const handleEdit = (expense) => {
    setEditingExpense(expense);
    setIsModalOpen(true);
  };

  const handleDelete = async (id) => {
    try {
      await expensesAPI.delete(id);
      fetchExpenses();
    } catch (error) {
      alert('Failed to delete expense');
      console.error('Error deleting expense:', error);
    }
  };

  const handleModalSuccess = () => {
    fetchExpenses();
  };

  const handleSearch = (e) => {
    setSearchTerm(e.target.value);
  };

  if (loading) {
    return (
      <div className="loading">
        <p>Loading...</p>
      </div>
    );
  }

  if (!user) {
    return <Login onLogin={handleLogin} />;
  }

  return (
    <div className="app">
      <header className="header">
        <div className="header-content">
          <h1>💼 Tax Claim Tracker</h1>
          <div className="user-info">
            <div className="user-badge">
              <span>{user.username}</span>
              <span className={`role-badge ${user.role}`}>{user.role}</span>
            </div>
            <button className="logout-btn" onClick={handleLogout}>
              Logout
            </button>
          </div>
        </div>
      </header>

      <main className="main-content">
        {user.role === 'admin' && <YearSettings />}
        
        <div className="controls">
          <input
            type="text"
            className="search-input"
            placeholder="🔍 Search by description or amount..."
            value={searchTerm}
            onChange={handleSearch}
          />
          {user.role === 'admin' && (
            <button className="btn btn-primary" onClick={handleAddNew}>
              ➕ Add New
            </button>
          )}
        </div>

        <ExpenseTable
          expenses={expenses}
          onEdit={handleEdit}
          onDelete={handleDelete}
          isAdmin={user.role === 'admin'}
        />
      </main>

      <ExpenseModal
        isOpen={isModalOpen}
        onClose={() => setIsModalOpen(false)}
        onSuccess={handleModalSuccess}
        expense={editingExpense}
      />
    </div>
  );
}

export default App;